import type { PublicGameState, RoomMember } from "@grundbesitz/shared";
import { TokenIcon } from "../../board/TokenIcon";

/** Token and name of a player. Name always goes with the token, color and figure never stand alone. */
export function PlayerChip({
  game,
  members,
  id,
  size = 20,
  you = false,
}: {
  game: PublicGameState;
  members: RoomMember[];
  id: string;
  size?: number;
  you?: boolean;
}) {
  const p = game.players.find((x) => x.id === id);
  const name = p?.name ?? members.find((m) => m.id === id)?.name ?? "Unbekannt";
  return (
    <span className="inline-flex items-center gap-1.5 min-w-0 align-middle">
      {p && <TokenIcon token={p.token} color={p.color} size={size} title={name} />}
      <span className="truncate font-semibold">{you ? `${name} (du)` : name}</span>
    </span>
  );
}
